/**
 * shadcn Checkbox (Tailwind 3 "new-york"), ported per the checklist in
 * agents/CODING_STANDARDS.md -> "Styling: two systems". Tri-state:
 * `checked="indeterminate"` renders a dash.
 *
 * Radix renders a <button role="checkbox">, so it needs an accessible name:
 * an `aria-label`, or a <label htmlFor> pointing at its `id`.
 */
import React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check, Minus } from 'lucide-react'

import { cn } from '../../utils/cn.js'

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    data-slot="checkbox"
    className={cn(
      'tw-peer tw-group tw-inline-flex tw-h-4 tw-w-4 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-control tw-border tw-border-primary tw-bg-background tw-shadow focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-bg-primary data-[state=checked]:tw-text-primary-foreground data-[state=indeterminate]:tw-bg-primary data-[state=indeterminate]:tw-text-primary-foreground',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      data-slot="checkbox-indicator"
      className="tw-flex tw-items-center tw-justify-center tw-text-current"
    >
      <Check
        aria-hidden="true"
        className="tw-h-3.5 tw-w-3.5 group-data-[state=indeterminate]:tw-hidden"
      />
      <Minus
        aria-hidden="true"
        className="tw-hidden tw-h-3.5 tw-w-3.5 group-data-[state=indeterminate]:tw-block"
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
